import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as GuaranteesReducer } from './Guarantees'

export * from './Guarantees'

export const types = {
  ...makeApiTypes('FETCH_GUARANTEES', 'guarantees'),
  ...makeApiTypes('FETCH_GUARANTEES_COUNT', 'guarantees'),
}

export const initialState = {
  guarantees: { busy: false, error: '', entities: null, count: null },
}

export default reduceReducers(
  GuaranteesReducer,
  // initialState MUST be last
  initialState,
)
